import { useCallback } from 'react'
import {
  useSharedValue,
  useAnimatedStyle,
  withSequence,
  withTiming,
  Easing,
  useReducedMotion,
} from 'react-native-reanimated'
import { notification, NotificationType } from '../utils/haptics'

interface UseShakeAnimationOptions {
  amplitude?: number
  duration?: number
  count?: number
  haptic?: boolean
}

export function useShakeAnimation(options: UseShakeAnimationOptions = {}) {
  const { amplitude = 8, duration = 60, count = 3, haptic = true } = options

  const reducedMotion = useReducedMotion()
  const translateX = useSharedValue(0)

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: translateX.value }],
  }))

  const shake = useCallback(() => {
    if (haptic) {
      void notification(NotificationType.Error)
    }

    if (reducedMotion) return

    const timingConfig = { duration, easing: Easing.linear }
    const steps: ReturnType<typeof withTiming>[] = []
    for (let i = 0; i < count * 2; i++) {
      steps.push(withTiming(i % 2 === 0 ? amplitude : -amplitude, timingConfig))
    }
    steps.push(withTiming(0, timingConfig))

    translateX.value = withSequence(...steps) as number
  }, [reducedMotion, haptic, amplitude, duration, count, translateX])

  return { animatedStyle, shake }
}
